/* Sticky add to cart bar: slides in after a scroll distance, follows the selected variant, and drives the main form. */
(() => {
  if (window.__ntStickyAtc) return;
  window.__ntStickyAtc = true;

  const bars = () => [...document.querySelectorAll('.nt-sticky')];
  const mainForm = (bar) => document.getElementById(bar.dataset.form);
  const mainIdInput = (bar) => mainForm(bar)?.querySelector('input[name="id"]');

  const toggle = () => {
    bars().forEach((bar) => {
      const limit = parseInt(bar.dataset.threshold, 10) || 0;
      bar.classList.toggle('is-visible', window.scrollY > limit);
    });
  };

  const syncFromMain = (bar) => {
    const input = mainIdInput(bar);
    if (!input) return;
    const select = bar.querySelector('[data-nt-sticky-select]');
    if (select && select.value !== input.value) select.value = input.value;
    const opt = select?.querySelector('option[value="' + input.value + '"]');
    const img = bar.querySelector('[data-nt-sticky-img]');
    if (img && opt && opt.dataset.image) { img.src = opt.dataset.image; img.removeAttribute('srcset'); }
    const price = document.getElementById('price-' + bar.dataset.section);
    const target = bar.querySelector('[data-nt-sticky-price]');
    if (price && target && price.innerHTML.trim()) target.innerHTML = price.innerHTML;
    const atc = mainForm(bar)?.querySelector('[name="add"]');
    const btn = bar.querySelector('.nt-sticky__btn');
    if (atc && btn) {
      const off = atc.hasAttribute('disabled');
      btn.toggleAttribute('disabled', off);
      if (off) btn.textContent = (atc.querySelector('span') || atc).textContent.trim();
    }
  };

  const syncAll = () => bars().forEach(syncFromMain);

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (t && t.matches && t.matches('[data-nt-sticky-select]')) {
      const bar = t.closest('.nt-sticky');
      const wanted = (t.selectedOptions[0]?.dataset.options || '').split('||');
      const root = document.querySelector('variant-selects[data-section="' + bar.dataset.section + '"]') || document;
      let last = null;
      wanted.forEach((value, i) => {
        const radio = [...root.querySelectorAll('input[type="radio"]')].find((r) => r.name.trim().endsWith('-' + (i + 1)) && r.value === value);
        if (radio) { if (!radio.checked) radio.click(); return; }
        const sel = root.querySelector('#Option-' + bar.dataset.section + '-' + i);
        if (sel && sel.value !== value) { sel.value = value; last = sel; }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (t && t.name === 'id') setTimeout(syncAll, 60);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('.nt-sticky__btn');
    if (!btn || btn.disabled) return;
    const bar = btn.closest('.nt-sticky');
    mainForm(bar)?.querySelector('[name="add"]')?.click();
  });

  window.addEventListener('scroll', toggle, { passive: true });
  window.addEventListener('resize', toggle);
  document.addEventListener('DOMContentLoaded', () => { toggle(); syncAll(); });
  toggle();
  [400, 1200].forEach((ms) => setTimeout(syncAll, ms));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => { setTimeout(syncAll, 50); setTimeout(syncAll, 400); });
  }
})();
